(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["mana-launch-offers"] && !Shopify.designMode) return;
  try {
    (() => {
    const expireOffers = () => document.querySelectorAll('[data-mana-offers]').forEach(offer => {
      if (Date.now() >= Date.parse(offer.dataset.expires)) offer.hidden = true;
    });
    expireOffers();
    document.addEventListener('visibilitychange', expireOffers);
    document.addEventListener('shopify:section:load', expireOffers);
    setInterval(expireOffers, 60000);
    document.addEventListener('click', async event => {
      const button = event.target.closest('[data-copy-code]');
      if (!button) return;
      const offer = button.closest('[data-mana-offers]');
      const status = offer.querySelector('.mana-offers__status');
      try {
        await navigator.clipboard.writeText(button.dataset.copyCode);
        status.textContent = button.dataset.copyCode + ' — ' + offer.dataset.copied;
        setTimeout(() => { status.textContent = ''; }, 2500);
      } catch {
        status.textContent = button.dataset.copyCode + ' — ' + offer.dataset.copyFailed;
      }
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
